import Client from './Clients/AxiosClient'
import { parseFilters } from './utils/ParseFilters'
const resource = 'marketing_campaigns'

export default {
  get (filters) {
    return Client.get(`${resource}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  getMarketingCampaign (id, filters) {
    return Client.get(`${resource}/${id}?${parseFilters(filters)}`)
      .then(response => response.data)
  },
  create (payload) {
    return Client.post(`${resource}`, payload)
      .then(response => response.data)
  },
  update (payload, id) {
    return Client.put(`${resource}/${id}`, payload)
      .then(response => response.data)
  },
  delete (id) {
    return Client.delete(`${resource}/${id}`)
      .then(response => response.data)
  },
  listMarketingCampaignAccounts (filters) {
    return Client.post(`${resource}/accounts/list`, filters)
      .then(response => response.data)
  },
  getTouchpointSalesData (accountId, touchpointDate) {
    return Client.get(`${resource}/touchpoints/sales_data?accountId=${accountId}&touchpointDate=${touchpointDate}`)
      .then(response => response.data)
  },
  getGrossOnlineSales (accountId, year) {
    return Client.get(`${resource}/gross/online/sales?accountId=${accountId}&year=${year}`)
      .then(response => response.data)
  },
  getCampaignOnlineSales (id) {
    return Client.get(`${resource}/campaign/${id}/online/sales`)
      .then(response => response.data)
  }
}
